import graphqlClient from "../../../apollo";

class SurveyResponseProvider {

    fetchStatistics(surveyId, filters = null){
        return graphqlClient.query({
            query: require('./gql/SurveyResponse/fetchStatistics.graphql'),
            variables: {surveyId, filters},
            fetchPolicy: "network-only"
        })
    }

    findSurveyResponse(id) {
        return graphqlClient.query({
            query: require('./gql/SurveyResponse/findSurveyResponse.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    fetchSurveyResponse() {
        return graphqlClient.query({
        query: require('./gql/SurveyResponse/fetchSurveyResponse.graphql'),
        fetchPolicy: "network-only"
        })
    }
    
    paginateSurveyResponse(pageNumber, itemsPerPage, filters = null) {
        return graphqlClient.query({
            query: require('./gql/SurveyResponse/paginateSurveyResponse.graphql'),
            variables: {pageNumber, itemsPerPage, filters},
            fetchPolicy: "network-only"
        })
    }

    createSurveyResponse(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/SurveyResponse/createSurveyResponse.graphql'),
            variables: {input}
        })
    }

}

export default new SurveyResponseProvider()


